import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient, } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'cargo-referencia';
const route = {
  listar: `${baseRef}`,
  listarPorTipoEntidade: (tipoEntidadeId: number) => `${baseRef}/entidade/${tipoEntidadeId}`,
  buscarPorId: (id: number) => `${baseRef}/${id}`,
};

@Injectable({
  providedIn: 'root'
})
export class CargoReferenciaService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private domainCache: DomainCacheService
  ) { }

  listar(): Observable<any> {
    return this.domainCache.getOrLoad(route.listar, () =>
      this.apiService.get<any>(`${route.listar}`, undefined, undefined, true)
    );
  }

  listarSubordinados(): Observable<any> {
    const key = `${route.listar}/subordinados`;
    return this.domainCache.getOrLoad(key, () =>
      this.apiService.get<any>(key, undefined, undefined, true)
    );
  }

  listarPorTipoEntidade(tipoEntidadeId: number): Observable<any> {
    const key = route.listarPorTipoEntidade(tipoEntidadeId);
    return this.domainCache.getOrLoad(key, () =>
      this.apiService.get<any>(key, undefined, undefined, true)
    );
  }

  buscarPorId(id: number): Observable<any> {
    return this.apiService.get<any>(route.buscarPorId(id));
  }
}
